import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

export const Label = ({ children, ...props }) => (
  <Box
    as='label'
    textStyle='bodySmall'
    fontWeight='fontWeightBold'
    {...props}
  >
    {children}
  </Box>
)

Label.propTypes = {
  children: PropTypes.node.isRequired,
}
